// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubHeader_wrapper__s4GyT","wrapper_size":"SubHeader_wrapper_size__3fFHz"};